// extracted by mini-css-extract-plugin
export default {"recos":"C5-z","productCardOverride":"D5-z","rowHasBadge":"E5-z"};